const addGroup = (state, action) => {
  switch (action.status) {
    case 'success':
    case 'error':
      return {
        ...state,
        createGroupDialogOpenFor: null,
      };
    default:
      return state;
  }
};

export default addGroup;
